import React, { useMemo } from "react";
import { Link } from "react-router-dom";
import styles from "./AppFooter.module.css";
import { useBranding } from "../../context/BrandingContext";
import { useAuth } from "../../hooks/useAuth";
import { localizedPath } from "../../hooks/useLocalizedNavigate";

/**
 * Stopka aplikacji — obecna na KAŻDEJ stronie (renderowana raz w Layout, na końcu
 * przewijanego obszaru treści). Celowo MINIMALNA i ledwo widoczna: jej główną rolą jest
 * odstęp między ostatnim elementem a krawędzią strony (koniec „ucięcia"). Treść: nazwa
 * aplikacji (z /admin/branding), dzisiejsza data, nazwa firmy — drobnym, przygaszonym tekstem.
 */
const AppFooter = () => {
    const { appName } = useBranding();
    const { user } = useAuth();

    const today = useMemo(
        () =>
            new Date().toLocaleDateString("pl-PL", {
                day: "numeric",
                month: "long",
                year: "numeric",
            }),
        []
    );

    const title = appName || "mPracownik";
    const company = user?.companyName || null;

    return (
        <footer className={styles.footer} role="contentinfo" aria-label="Stopka aplikacji">
            <span className={styles.name}>{title}</span>
            <span className={styles.sep} aria-hidden="true">·</span>
            <span>{today}</span>
            {company && (
                <>
                    <span className={styles.sep} aria-hidden="true">·</span>
                    <span>{company}</span>
                </>
            )}
            {/* [polecenie właściciela 2026-09-20] „link do regulaminu oraz ciasteczek oraz do rodo
                ma być też w stopce" — te same publiczne adresy, co na stronie logowania. */}
            <span className={styles.sep} aria-hidden="true">·</span>
            <Link className={styles.link} to={localizedPath("dokumentRegulamin")}>Regulamin</Link>
            <span className={styles.sep} aria-hidden="true">·</span>
            <Link className={styles.link} to={localizedPath("dokumentRodo")}>RODO</Link>
            <span className={styles.sep} aria-hidden="true">·</span>
            <Link className={styles.link} to={localizedPath("dokumentCookies")}>Cookies</Link>
        </footer>
    );
};

export default AppFooter;
